import { useMemo } from 'react';
import { type INotesSortingOrder } from '@/types/INote';
import styles from './index.module.scss';

export default function ButtonSort ({
  notesSortingOrder,
  onButtonSortClick,
}: {
  notesSortingOrder: INotesSortingOrder;
  onButtonSortClick: () => void;
}) {
  const buttonText = useMemo(() => {
    switch (notesSortingOrder) {
      case 'ascending':
        return 'Najstarsze';
      case 'descending':
        return 'Najnowsze';
      default:
        return '';
    }
  }, [notesSortingOrder]);

  return (
    <button
      className={styles['button-sort']}
      data-e='notes-sortbtn'
      onClick={onButtonSortClick}
      type='button'
    >
      {buttonText}
      <svg
        className={styles['button-sort__icon']}
        data-sort={notesSortingOrder}
        viewBox='0 0 16 16'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M8 10 4.667 6.667h6.667z'
          fill='currentColor'
        />
      </svg>
    </button>
  );
}
